import { Term, Maybe } from '~/jobiqo/types/types';

/**
 * Flattens an array based on the "children" key.
 */
export const flattenForChildren = (items: any[]) => {
  let flat: any[] = [];
  items.forEach((item) => {
    flat = [...flat, item];
    if (Array.isArray(item.children) && item.children.length > 0) {
      flat = [...flat, ...flattenForChildren(item.children)];
    }
  });

  return flat;
};

/**
 * Transforms a term field into a type of targetId:tid.
 */
export const mapTermFieldSingle = (term: Term | null | undefined) => {
  return term ? term : null;
};

/**
 * Transforms a list of term fields into an array of type of targetId:tid.
 */
export const mapTermFieldMultiple = (
  terms: Maybe<Term>[] | null | undefined,
) => {
  return terms ? terms : [];
};
